import React from "react";
import { MenuIcon } from "lucide-react";
import { LogoView } from "@/components/LogoView.tsx";
import { useLocation } from "wouter";

const ItemsNavBar: React.FC = (props) => {
	const [_, setLocation] = useLocation();

	const handleBackClick = () => {
		setLocation("/");
	};

	return (
		<div className={"flex gap-2 items-center justify-between mb-5"}>
			<div className={"flex items-center gap-2"}>
				<MenuIcon
					onClick={handleBackClick}
					width={20}
					className={"cursor-pointer"}
				/>
				<LogoView size={0} />
			</div>
			{/*<SettingsMenu/>*/}
		</div>
	);
};

export { ItemsNavBar };
